import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  listBillingReconciliationCatalog,
  markBillingReconciliationCatalogItemReviewed,
  updateBillingReconciliationCatalogItem,
} from './billingReconciliationApi.js';

const catalogKey = ({ program, reviewed, limit, offset } = {}) => ['billingRecon', 'catalog', program || null, reviewed ?? null, limit || null, offset || null];
const noRetry = { retry: false };

const listRows = (payload) => {
  if (Array.isArray(payload)) return payload;
  return payload?.rows || [];
};

export const useBillingReconciliationCatalog = (params = {}, options = {}) =>
  useQuery({
    queryKey: catalogKey(params),
    queryFn: ({ signal }) => listBillingReconciliationCatalog({ ...params, signal }),
    enabled: options.enabled ?? true,
    select: listRows,
    staleTime: 60 * 1000,
    ...noRetry,
    ...options,
  });

export const useUpdateBillingReconciliationCatalogItem = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateBillingReconciliationCatalogItem,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'catalog'] });
    },
  });
};

export const useMarkBillingReconciliationCatalogItemReviewed = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markBillingReconciliationCatalogItemReviewed,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['billingRecon', 'catalog'] });
    },
  });
};
